/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  extensaoArquivo: string;
  tamanhoArquivo?: number;
  base64: string;
  /** Apenas para o texto do toast — a troca usa o mesmo endpoint do envio. */
  isReplace?: boolean;
}

export function useComprovanteAto() {
  const postData = async (props: Props) => {
    const ANEXAR_LAUDO = `${backofficeEnviroment}/common/backoffice/juridico/comprovante-ato/v1`;
    const { data } = await instance.post(ANEXAR_LAUDO, {
      idOportunidade: props.idOportunidade,
      extensaoArquivo: `.${props.extensaoArquivo}`,
      // tamanhoArquivo: props.tamanhoArquivo,
      base64: props.base64,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: (_data, variables) => {
      toast.success(
        variables?.isReplace
          ? "Comprovante de ato substituído com sucesso!"
          : "Comprovante de ato anexado com sucesso!"
      );
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao anexar comprovante de ato. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
